<template>
  <div>
    <van-notify v-model="show" :type="type">
      <div class="w-full">
        <div class="truncate">
          {{ title }}
        </div>
        <div>
          <span>{{ message }}</span>
        </div>
      </div>
    </van-notify>
  </div>
</template>

<script>
export default {
  name: 'CustomNotify',
  data() {
    return {
      show: false,
      message: '',
      title: '',
      type: ''
    }
  },
  created() {},
  methods: {
    showNotify(data) {
      this.title = data.title
      this.type = data.type
      this.message = data.message
      this.show = true
      setTimeout(() => {
        this.show = false
      }, 2000)
    }
  }
}
</script>

<style scoped></style>
